import { CATEGORIES } from '../constants';
export const combinationTypes = {
    ONE_PER_PERIOD: 'ONE_PER_PERIOD',
    ONE_PER_PLAYER: 'ONE_PER_PLAYER',
    TOUCHDOWN_SCORERS: 'TOUCHDOWN_SCORERS',
    DEFAULT: 'DEFAULT',
};
const touchdownExclusivePeriods = ['first', 'last', 'primero', 'último'];
export const isIncompatible = {
    ONE_PER_PERIOD: (selA, selB) => selA.period === selB.period,
    ONE_PER_PLAYER: (selA, selB) => selA.period === selB.period && selA.player === selB.player,
    TOUCHDOWN_SCORERS: (selA, selB) => {
        if (touchdownExclusivePeriods.includes(selA.period.toLowerCase())
            || touchdownExclusivePeriods.includes(selA.period.toLowerCase())) {
            return selA.period === selB.period;
        }
        return selA.period === selB.period && selA.id === selB.id;
    },
    DEFAULT: (selA, selB) => Boolean(selA.type
        && selB.type
        && selA.type === selB.type
        && selA.team === selB.team
        && selA.period === selB.period),
};
export const combinations = {
    // basketball and american football match markets
    [CATEGORIES.POINTS_HANDICAP]: {
        combinationType: combinationTypes.ONE_PER_PERIOD,
    },
    [CATEGORIES.MONEY_LINE]: {
        combinationType: combinationTypes.ONE_PER_PERIOD,
    },
    [CATEGORIES.TOTAL_POINTS]: {
        combinationType: combinationTypes.ONE_PER_PERIOD,
    },
    // basketball player markets
    [CATEGORIES.BLOCKS]: {
        combinationType: combinationTypes.ONE_PER_PLAYER,
    },
    [CATEGORIES.STEALS]: {
        combinationType: combinationTypes.ONE_PER_PLAYER,
    },
    [CATEGORIES.TURNOVERS]: {
        combinationType: combinationTypes.ONE_PER_PLAYER,
    },
    [CATEGORIES.BLOCKS_STEALS]: {
        combinationType: combinationTypes.ONE_PER_PLAYER,
    },
    [CATEGORIES.THREE_MADE]: {
        combinationType: combinationTypes.ONE_PER_PLAYER,
    },
    [CATEGORIES.ASSISTS]: {
        combinationType: combinationTypes.ONE_PER_PLAYER,
    },
    [CATEGORIES.REBOUNDS]: {
        combinationType: combinationTypes.ONE_PER_PLAYER,
    },
    [CATEGORIES.ASSISTS_REBOUNDS]: {
        combinationType: combinationTypes.ONE_PER_PLAYER,
    },
    [CATEGORIES.POINTS]: {
        combinationType: combinationTypes.ONE_PER_PLAYER,
    },
    [CATEGORIES.POINTS_ASSISTS]: {
        combinationType: combinationTypes.ONE_PER_PLAYER,
    },
    [CATEGORIES.POINTS_REBOUNDS]: {
        combinationType: combinationTypes.ONE_PER_PLAYER,
    },
    [CATEGORIES.POINTS_ASSISTS_REBOUNDS]: {
        combinationType: combinationTypes.ONE_PER_PLAYER,
    },
    [CATEGORIES.DOUBLE_DOUBLE]: {
        combinationType: combinationTypes.ONE_PER_PLAYER,
    },
    [CATEGORIES.TRIPLE_DOUBLE]: {
        combinationType: combinationTypes.ONE_PER_PLAYER,
    },
    // american football player markets
    [CATEGORIES.PLAYER_TO_SCORE_TOUCHDOWN]: {
        combinationType: combinationTypes.TOUCHDOWN_SCORERS,
    },
    [CATEGORIES.EXTRA_POINT_MADE]: {
        combinationType: combinationTypes.ONE_PER_PLAYER,
    },
    [CATEGORIES.FIELD_GOAL_MADE]: {
        combinationType: combinationTypes.ONE_PER_PLAYER,
    },
    [CATEGORIES.INTERCEPTIONS]: {
        combinationType: combinationTypes.ONE_PER_PLAYER,
    },
    [CATEGORIES.KICKING_POINTS]: {
        combinationType: combinationTypes.ONE_PER_PLAYER,
    },
    [CATEGORIES.LONGEST_PASSING_COMPLETION]: {
        combinationType: combinationTypes.ONE_PER_PLAYER,
    },
    [CATEGORIES.LONGEST_RECEPTION]: {
        combinationType: combinationTypes.ONE_PER_PLAYER,
    },
    [CATEGORIES.PASSING_ATTEMPTS]: {
        combinationType: combinationTypes.ONE_PER_PLAYER,
    },
    [CATEGORIES.PASSING_COMPLETIONS]: {
        combinationType: combinationTypes.ONE_PER_PLAYER,
    },
    [CATEGORIES.PASSING_TOUCHDOWNS]: {
        combinationType: combinationTypes.ONE_PER_PLAYER,
    },
    [CATEGORIES.PASSING_YARDS]: {
        combinationType: combinationTypes.ONE_PER_PLAYER,
    },
    [CATEGORIES.RECEIVING_YARDS]: {
        combinationType: combinationTypes.ONE_PER_PLAYER,
    },
    [CATEGORIES.RECEPTIONS]: {
        combinationType: combinationTypes.ONE_PER_PLAYER,
    },
    [CATEGORIES.RUSHING_ATTEMPTS]: {
        combinationType: combinationTypes.ONE_PER_PLAYER,
    },
    [CATEGORIES.RUSHING_YARDS]: {
        combinationType: combinationTypes.ONE_PER_PLAYER,
    },
    [CATEGORIES.TACKLES_ASSISTS]: {
        combinationType: combinationTypes.ONE_PER_PLAYER,
    },
    'DEFAULT': {
        combinationType: combinationTypes.DEFAULT,
    }
};
